import { ActionIcon, Group, Paper, Title } from '@mantine/core';
import { PropsWithChildren, ReactElement } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import { modals } from '@mantine/modals';
import { CenteredLoading } from './CenteredLoading';

interface Props extends PropsWithChildren {
  isLoading?: boolean;
  title?: string;
  infoModal?: ReactElement;
  testId?: string;
}

export const PaperWithBorder = ({ isLoading = false, children, title, infoModal, testId }: Props) => {
  const openInfoModal = () =>
    modals.open({
      title,
      size: 'xl',
      children: infoModal,
    });

  return (
    <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder data-testid={testId}>
      {isLoading && <CenteredLoading />}
      {!isLoading && title && (
        <Group gap={'xs'} justify={'flex-start'}>
          <Title order={4}>{title}</Title>
          {infoModal && (
            <ActionIcon c={'var(--mantine-color-gray-6)'} variant={'subtle'}>
              <BsQuestionCircle size={16} onClick={openInfoModal} title={title} />
            </ActionIcon>
          )}
        </Group>
      )}
      {!isLoading && children}
    </Paper>
  );
};
